module.exports = {
  methods: {
    t: window.I18n.t.bind(window.I18n)
  }
};

